/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDashboardProfileFromJSON, ApiDashboardProfileToJSON, } from './ApiDashboardProfile';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiUserDashboardProfileFromJSON(json) {
    return ApiUserDashboardProfileFromJSONTyped(json, false);
}
export function ApiUserDashboardProfileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dashboardProfile': !exists(json, 'dashboardProfile') ? undefined : ApiDashboardProfileFromJSON(json['dashboardProfile']),
        'dashboardProfileId': !exists(json, 'dashboardProfileId') ? undefined : json['dashboardProfileId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'presetKey': !exists(json, 'presetKey') ? undefined : json['presetKey'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'user': !exists(json, 'user') ? undefined : ApiUserFromJSON(json['user']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}
export function ApiUserDashboardProfileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dashboardProfile': ApiDashboardProfileToJSON(value.dashboardProfile),
        'dashboardProfileId': value.dashboardProfileId,
        'id': value.id,
        'presetKey': value.presetKey,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'user': ApiUserToJSON(value.user),
        'userId': value.userId,
    };
}
